import Expander from '@/modules/Expander/Expander.js';

class CardEvent {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.findElements();

    if (this.needExpander()) {
      this.initExpander();
    }
  }

  findElements() {
    this.content = this.rootElement.querySelector('[data-entity="content"]');
    this.contentDesc = this.rootElement.querySelector('[data-entity="content-desc"]');
    this.contentPic = this.rootElement.querySelector('[data-entity="content-pic"]');
    this.toggler = this.rootElement.querySelector('[data-entity="toggler"]');
  }

  initExpander() {
    new Expander(this.rootElement, {
      shownClass: 'card-event_expanded',
      hiddenClass: 'card-event_collapsed',
    });

    this.renderToggler();
  }

  needExpander() {
    if (this.contentPic) return true;

    if (this.content && this.contentDesc) {
      const contentHeight = this.content.offsetHeight;
      const contentDescHeight = this.contentDesc.offsetHeight;

      if (contentDescHeight > contentHeight) return true;
    }

    return false;
  }

  renderToggler() {
    this.toggler.classList.add('card-event__toggler_shown');
  }
}

export default CardEvent;
